import { Skeleton, Spin } from 'antd'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { categoryBasedStyle, formatDateWithOrdinal } from '../../..'
import EmptyStateImage from '../../../../../../src/components/icons/EmptyState'
import {
  Container,
  DateDisplay,
  EmptyStateContainer,
  HorizontalLine,
  SpinWrapper,
} from '../style'
import EventCard from './EventCard'

const EventsList = ({
  state,
  setState,
  fetchEventsList,
  listDate,
  handleSingleEventClick,
}) => {
  const fetchMoreData = async () => {
    let pageNo = state.pageNo + 1
    if (state?.eventListCurrentObj?.totalPage == pageNo) {
      setState(prevState => ({
        ...prevState,
        pageNo: prevState.pageNo + 1,
        hasMoreData: false,
      }))
      return
    }
    setState(prevState => ({
      ...prevState,
      pageNo: prevState.pageNo + 1,
      hasMoreData: true,
    }))
    fetchEventsList({
      pageNo: pageNo,
      loadMore: true,
      from: listDate,
      forCalendar: false,
    })
  }

  return (
    <>
      {state.loading ? (
        <SpinWrapper center>
          <Spin />
        </SpinWrapper>
      ) : state?.eventsList?.length === 0 ? (
        <EmptyStateContainer>
          <EmptyStateImage />
          No event available
        </EmptyStateContainer>
      ) : (
        <InfiniteScroll
          dataLength={state?.eventsList?.length}
          next={fetchMoreData}
          hasMore={
            state.eventStatus !== 'DRAFT' && 
            state?.eventListCurrentObj?.totalPage !== (state?.eventListCurrentObj?.page + 1)
          }
          loader={
            state.hasMoreData ? (
              <Skeleton paragraph={{ rows: 2 }} active />
            ) : null
          }
          height={'60vh'}
        >
          {state?.eventFullList?.map(item => {
            return (
              <>
                <DateDisplay>
                  {item.date === 'noDate' ? ' ' : formatDateWithOrdinal(new Date(item.date))}
                </DateDisplay>
                {item?.eventsList?.map((item, index) => {
                  return (
                      <Container key={index + 'event'}>
                        <EventCard
                          variant="primary"
                          // eventDay={item.eventDetails}
                          state={state}
                          eventName={item.title}
                          eventCategoryText={item?.category}
                          allDayEvent={item.allDayEvent}
                          isRegister={item?.isRegister}
                          location={item?.location ? item?.location[0] : ''}
                          categoryBasedObj={categoryBasedStyle(item.category)}
                          handleClick={() => handleSingleEventClick(item)}
                          selectedData={item}
                          startTime={item.startTime}
                          endTime={item.endTime}
                          // isApplied={item?.studentEventMapping?.length > 0}
                          occurrence={state?.occurence == 'UPCOMING'}
                          handleDeleteEvent={() =>
                            handleSingleEventClick(item, 'delete')
                          }
                          handleEditEvent={() =>
                            handleSingleEventClick(item, 'edit')
                          }
                          handleCopyEvent={() =>
                            handleSingleEventClick(item, 'copy')
                          }
                        />
                      </Container>
                  )
                })}
                <HorizontalLine />
              </>
            )
          })}
        </InfiniteScroll>
      )}
    </>
  )
}
export default EventsList
